import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { agentApiRef, AgentClient } from './api';

import { rootRouteRef } from './routes';

export const clusterAgentPlugin = createPlugin({
  id: 'cluster-agent',
  apis: [
    createApiFactory({
      api: agentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new AgentClient({ discoveryApi, identityApi }),
    }),
  ],
  routes: {
    entityContent: rootRouteRef,
  },
});

export const EntityMetricContent =
  clusterAgentPlugin.provide(
    createRoutableExtension({
      name: 'EntityMetricContent',
      component: () => import('./components/Agent').then(m => m.MetricList),
      mountPoint: rootRouteRef,
    }),
  );

export const EntityClusterList = clusterAgentPlugin.provide(
  createRoutableExtension({
    name: 'EntityClusterList',
    component: () => import('./components/Agent').then(m => m.ClusterList),
    mountPoint: rootRouteRef,
  }),
);

export const EntityClusterContentAllTable =
  clusterAgentPlugin.provide(
    createRoutableExtension({
      name: 'EntityClusterContentAllTable',
      component: () =>
        import('./components/Agent').then(m => m.ClusterAllTable),
      mountPoint: rootRouteRef,
    }),
  );
